/**
 * Defines the site reducer.
 */
import { IAction, IFilterQuery, ISite } from '@shared/types';
import { XprtDataActions } from '../../actions';
import { XVIError } from '@shared/models';

export interface IStoreState {
  list: ISite[];
  isListLoaded: boolean;
  total: number;
  query: IFilterQuery;
  byCompany: string;
  errors: XVIError[];
  isShowStoresModal: boolean;
  selectedStores: string[];
  modalOptions: any;
  recent: ISite[];
  siteGroups: {
    [key: string]: string;
  };
}
const INITIAL_STATE: IStoreState = {
  list: [],
  isListLoaded: false,
  total: null,
  query: {
    filter: '',
    top: null,
    skip: null,
  },
  byCompany: null,
  errors: [],
  isShowStoresModal: false,
  selectedStores: [],
  modalOptions: {
    forceSelect: false,
    masterList: true,
  },
  recent: [],
  siteGroups: {},
};

export const storesReducer = (
  state: IStoreState = INITIAL_STATE,
  action: IAction,
): IStoreState => {
  const { payload } = action;

  switch (action.type) {
    case XprtDataActions.FETCH_STORES:
      return Object.assign({}, state, {
        isStoresRequestInProgress: true,
        errors: [],
        query: payload.query,
      });

    case XprtDataActions.FETCH_STORES_SUCCESS:
      return Object.assign({}, state, {
        isStoresRequestInProgress: false,
        total: payload.total,
        list: payload.items,
        isListLoaded: true,
      });

    case XprtDataActions.FETCH_STORES_ERROR:
      return Object.assign({}, state, {
        errors: payload,
      });

    case XprtDataActions.SELECT_STORES:
      return Object.assign({}, state, {
        selectedStores: payload.selectedStores,
      });

    case XprtDataActions.SHOW_STORES_MODAL:
      return Object.assign({}, state, {
        isShowStoresModal: true,
        modalOptions: payload.options,
      });

    case XprtDataActions.HIDE_STORES_MODAL:
      return Object.assign({}, state, {
        isShowStoresModal: false,
      });

    default:
      return state;
  }
};
